module.exports = __webpack_public_path__ + "static/media/img000243.c29f02a6.jpg";